const TOOLS_SELECTOR = 'mega-article-tools[data-placement="top"]';
const GENERATED_BOTTOM_CLASS = 'mega-article-tools-generated-bottom';

class MegaArticleTools extends HTMLElement {
  connectedCallback() {
    if (this.dataset.placement !== 'top') return;

    this.initialize();
  }

  disconnectedCallback() {
    this.cleanupReturnButton();
    this.removeGeneratedBottom();
  }

  initialize() {
    const toc = this.querySelector('[data-mega-article-toc]');
    const tocList = this.querySelector('[data-mega-article-toc-list]');

    if (!toc || !tocList) return;

    this.cleanupReturnButton();
    this.removeGeneratedBottom();
    tocList.replaceChildren();

    const articleSections = this.getArticleSections();
    const headings = articleSections.flatMap((section) =>
      Array.from(section.querySelectorAll('h2, h3'))
    );
    const visibleHeadings = headings.filter(
      (heading) => heading.textContent.trim() !== ''
    );

    if (visibleHeadings.length === 0) {
      toc.hidden = true;
      this.setReturnButtonVisibility(false);
      return;
    }

    toc.hidden = false;

    const usedIds = new Set(
      Array.from(
        document.querySelectorAll('[id]'),
        (element) => element.id
      )
    );

    visibleHeadings.forEach((heading, index) => {
      const headingId = this.ensureHeadingId(
        heading,
        index,
        usedIds
      );

      const item = document.createElement('li');
      const link = document.createElement('a');

      item.className =
        `mega-article-toc__item ` +
        `mega-article-toc__item--${heading.tagName.toLowerCase()}`;

      link.className = 'mega-article-toc__link';
      link.href = `#${headingId}`;
      link.textContent = heading.textContent.trim();

      item.append(link);
      tocList.append(item);
    });

    this.renderBottomMeta(articleSections);
    this.initializeReturnButton(toc);
  }

  getArticleSections() {
    const toolsSection = this.closest('.shopify-section');
    if (!toolsSection) return [];

    const sections = [];
    let sibling = toolsSection.nextElementSibling;

    while (sibling) {
      if (
        sibling.classList.contains('shopify-section') &&
        !sibling.classList.contains(GENERATED_BOTTOM_CLASS)
      ) {
        sections.push(sibling);
      }

      sibling = sibling.nextElementSibling;
    }

    return sections;
  }

  renderBottomMeta(articleSections) {
    const lastSection = articleSections.at(-1);
    const sourceBackground = this.querySelector(
      ':scope > .section-background'
    );
    const sourceSection = this.querySelector(
      '.mega-article-tools__section'
    );
    const sourceMeta = this.querySelector(
      '.mega-article-tools__meta'
    );

    if (
      !lastSection ||
      !sourceSection ||
      !sourceMeta ||
      sourceMeta.children.length === 0
    ) {
      return;
    }

    const wrapper = document.createElement('div');
    const section = document.createElement('div');
    const inner = document.createElement('div');

    wrapper.className =
      `shopify-section ${GENERATED_BOTTOM_CLASS}`;

    wrapper.dataset.megaArticleBottomFor =
      this.dataset.sectionId || '';

    section.className = sourceSection.className;
    section.classList.add(
      'mega-article-tools__section--generated-bottom'
    );
    section.style.cssText = sourceSection.style.cssText;

    inner.className = 'mega-article-tools__inner';
    inner.append(sourceMeta.cloneNode(true));

    section.append(inner);

    if (sourceBackground) {
      wrapper.append(sourceBackground.cloneNode(true));
    }

    wrapper.append(section);
    lastSection.after(wrapper);
  }

  removeGeneratedBottom() {
    const sectionId = this.dataset.sectionId || '';

    document
      .querySelectorAll(`.${GENERATED_BOTTOM_CLASS}`)
      .forEach((element) => {
        if (
          element.dataset.megaArticleBottomFor === sectionId
        ) {
          element.remove();
        }
      });
  }

  ensureHeadingId(heading, index, usedIds) {
    if (heading.id) return heading.id;

    const slug = heading.textContent
      .trim()
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    const baseId =
      `mega-${slug || `section-${index + 1}`}`;

    let uniqueId = baseId;
    let duplicateIndex = 2;

    while (usedIds.has(uniqueId)) {
      uniqueId = `${baseId}-${duplicateIndex}`;
      duplicateIndex += 1;
    }

    heading.id = uniqueId;
    usedIds.add(uniqueId);

    return uniqueId;
  }

  initializeReturnButton(toc) {
    const returnButton = this.querySelector(
      '[data-mega-article-toc-return]'
    );

    if (!returnButton) return;

    const updateVisibility = () => {
      this.setReturnButtonVisibility(
        toc.getBoundingClientRect().bottom < 100
      );
    };

    updateVisibility();

    window.addEventListener(
      'scroll',
      updateVisibility,
      { passive: true }
    );

    this.fallbackScrollHandler = updateVisibility;
  }

  cleanupReturnButton() {
    if (this.fallbackScrollHandler) {
      window.removeEventListener(
        'scroll',
        this.fallbackScrollHandler
      );

      this.fallbackScrollHandler = null;
    }
  }

  setReturnButtonVisibility(visible) {
    const returnButton = this.querySelector(
      '[data-mega-article-toc-return]'
    );

    if (!returnButton) return;

    returnButton.hidden = !visible;
  }
}

if (!customElements.get('mega-article-tools')) {
  customElements.define(
    'mega-article-tools',
    MegaArticleTools
  );
}

const refreshMegaArticleTools = () => {
  document
    .querySelectorAll(TOOLS_SELECTOR)
    .forEach((component) => component.initialize());
};

document.addEventListener(
  'shopify:section:load',
  refreshMegaArticleTools
);

document.addEventListener(
  'shopify:section:unload',
  refreshMegaArticleTools
);

document.addEventListener(
  'shopify:section:reorder',
  refreshMegaArticleTools
);